module.exports = __webpack_public_path__ + "media/application/images/car-background-a71df4adc3081c8c75063d07ff2816a4.jpg";